/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSvgInfoAdminSecurityExpert } from '../fn/svg-info-admin-security-expert-controller/get-svg-info-admin-security-expert';
import { GetSvgInfoAdminSecurityExpert$Params } from '../fn/svg-info-admin-security-expert-controller/get-svg-info-admin-security-expert';
import { getSvgInfoAdminSecurityExperts } from '../fn/svg-info-admin-security-expert-controller/get-svg-info-admin-security-experts';
import { GetSvgInfoAdminSecurityExperts$Params } from '../fn/svg-info-admin-security-expert-controller/get-svg-info-admin-security-experts';
import { SecurityExpertDto } from '../models/security-expert-dto';


/**
 * Manages SVG info admin security experts
 */
@Injectable({ providedIn: 'root' })
export class SvgInfoAdminSecurityExpertControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSvgInfoAdminSecurityExperts()` */
  static readonly GetSvgInfoAdminSecurityExpertsPath = '/svg-info-admin/security-experts';

  /**
   * Get all security experts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSvgInfoAdminSecurityExperts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgInfoAdminSecurityExperts$Response(params?: GetSvgInfoAdminSecurityExperts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecurityExpertDto>>> {
    return getSvgInfoAdminSecurityExperts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all security experts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSvgInfoAdminSecurityExperts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgInfoAdminSecurityExperts(params?: GetSvgInfoAdminSecurityExperts$Params, context?: HttpContext): Observable<Array<SecurityExpertDto>> {
    return this.getSvgInfoAdminSecurityExperts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SecurityExpertDto>>): Array<SecurityExpertDto> => r.body)
    );
  }

  /** Path part for operation `getSvgInfoAdminSecurityExpert()` */
  static readonly GetSvgInfoAdminSecurityExpertPath = '/svg-info-admin/security-experts/{id}';

  /**
   * Get a security expert
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSvgInfoAdminSecurityExpert()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgInfoAdminSecurityExpert$Response(params: GetSvgInfoAdminSecurityExpert$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityExpertDto>> {
    return getSvgInfoAdminSecurityExpert(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a security expert
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSvgInfoAdminSecurityExpert$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgInfoAdminSecurityExpert(params: GetSvgInfoAdminSecurityExpert$Params, context?: HttpContext): Observable<SecurityExpertDto> {
    return this.getSvgInfoAdminSecurityExpert$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecurityExpertDto>): SecurityExpertDto => r.body)
    );
  }

}
